import React from "react";
import { connect } from "react-redux";

import {
  getDashboardPath,
  getOnboardingPath,
  UNDER_REVIEW_GIF,
} from "../../../constants";

import Button from "../../../components/formElements/button/Button";

import * as actions from "../../../store/actions";
import { getUserData } from "../../../utils/localStorage";

const ProfileComplete = ({ logout, history, authInit, updateDoctorStatus }) => {
  const status = getUserData()?.doctor_status;
  const reason = getUserData()?.reason;

  return (
    <div className="container text-center" style={{ maxWidth: 550 }}>
      <p className="header mt-5 mb-5" style={{ fontSize: 20 }}>
        <span className="change-primary-color mx-auto">
          {status === "ACCEPTED" && `Your profile is accepted`}
          {status === "DENIED" && `Your profile is denied`}
          {status === "PENDING" && `Your profile is under review`}
        </span>
      </p>
      <img src={UNDER_REVIEW_GIF} alt="" height="296px" width="394px" />{" "}
      <p>
        {status === "DENIED" && `Reason: ${reason}`}
        {status === "PENDING" &&
          `Your profile has been submitted and will be reviewed by our team. You
        will be notified once it is done.`}
        {status === "ACCEPTED" && `Your profile has been approved.`}
      </p>
      {status === "DENIED" && (
        <p>Send for re-approval once profile is updated</p>
      )}
      {status === "DENIED" && (
        <>
          <Button
            className="w-75"
            label="Update Profile"
            onClick={() => {
              authInit(getOnboardingPath("/step1"), true);
              history.push(getOnboardingPath("/step1"));
            }}
          />
          <Button
            type="outline"
            className="w-75"
            label="Send for re-approval"
            onClick={() => {
              updateDoctorStatus(
                {
                  denial_reason: null,
                  status: "PENDING",
                  block_reason: null,
                },
                () => logout()
              );
            }}
          />
        </>
      )}
      {status === "PENDING" && (
        <Button className="w-75" label="Sign Out" onClick={() => logout()} />
      )}
      {status === "ACCEPTED" && (
        <Button
          className="w-75"
          label="Go To Dashboard"
          onClick={() => history.push(getDashboardPath("/appointments"))}
        />
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(actions.logout()),
  authInit: (path, flag) => dispatch(actions.authInit(path, flag)),
  updateDoctorStatus: (payload, cb) =>
    dispatch(actions.updateDoctorStatus(payload, cb)),
});

export default connect(undefined, mapDispatchToProps)(ProfileComplete);
